import { ResolveFn, Router } from '@angular/router';
import { QrCode } from '../../models/qr-code.model';
import { inject } from '@angular/core';
import { QrCodeService } from '../../../services/qr-code/qr-code.service';
import { catchError, EMPTY } from 'rxjs';

export const qrCodeResolver: ResolveFn<QrCode> = (route) => {
  const qrCodeService = inject(QrCodeService);
  const router = inject(Router);
  const qrCodeId = route.paramMap.get('qrCodeId')!;

  return qrCodeService.getQrCodeById(qrCodeId).pipe(
    catchError(() => {
      router.navigate(['/not-found'], {
        queryParams: { details: 'O QR Code informado não existe' },
        queryParamsHandling: 'merge'
      });
      return EMPTY;
    })
  );
};
